import {Box} from 'exsportia-components'
import React, {FC, useCallback} from 'react'
import {useNavigate} from 'react-router-dom'

import {NavMenu} from '../../../components/nav-menu/nav-menu'
import {GridLayoutHeader} from '../../../layout/grid-layout/headers/grid-layout-header'
import {Chevron} from '../../../ui/components/chevron/chevron'

type HeaderProps = {
  tabsSettings: ({
    text: string,
    isActive: boolean,
    onClick: () => void
  })[]
}

export const TabbedHeader: FC<HeaderProps> = ({tabsSettings}) => { // TODO: move to common
  const navigate = useNavigate()
  const handleGoBack = useCallback(() => {
    navigate(-1)
  }, [navigate])
  return (
    <GridLayoutHeader
      left={
        <Box
          onClick={handleGoBack}
          width={'32px'}
        >
          <Chevron
            direction={'left'}
            styleType={'simple'}
          />
        </Box>
      }
      center={
        <NavMenu
          isNested={true}
          tabsSettings={tabsSettings}
        />
      }
    />
  )
}